const generateRandomNumbersString = () => {
  return Array.from({ length: 8 }, () => Math.floor(Math.random() * 10)).join('');
};

export const generateFileName = (type?: string) => {
  return type + '_' + generateRandomNumbersString();
};
